import React from "react";
import MarkdownVideo from "../../../components/videoPlayer/markdownVideo";

// @ts-ignore
export function videoConfig({ node, props, width }){
    if (props.href && props.href.startsWith('https://www.youtube.com')) {
    return <MarkdownVideo url={props.href} width={width}/>;
    }
    return <a {...props} />;
}